import { useQuery } from '@tanstack/react-query';
import { SortOrder } from 'hooks/useTableControls';
import { PaginationQueryParams } from 'types/queryTypes';
import { MassiveTransaction } from 'types/massiveTransactionTypes';
import { fetchFromApi, fetchBlobFromApi, downloadBlob } from 'api/apiClient';

const TRANSACTIONS_QUERY_KEY = 'transactions';
const REACT_APP_DARWIN_MASSIVE_LOAD_URL =
  process.env.REACT_APP_DARWIN_MASSIVE_LOAD_URL;
const REACT_APP_DARWIN_URL = process.env.REACT_APP_DARWIN_URL;

/**
 * Fetch transactions.
 */
export const useGetMassiveTransactions = ({
  companyId,
  page = 1,
  limit = 10,
  query = '',
  sortOrder = { sortBy: 'createdAt', order: 'DESC' },
}: PaginationQueryParams & { companyId: string } & { sortOrder: SortOrder }) =>
  useQuery({
    queryKey: [TRANSACTIONS_QUERY_KEY, limit, page, query, sortOrder],
    queryFn: () =>
      fetchFromApi<MassiveTransaction[]>(
        `${REACT_APP_DARWIN_MASSIVE_LOAD_URL}/api/massive-loads/company/${companyId}?limit=${limit}&page=${page}&search=${query}&order=${sortOrder.order}&sortBy=${sortOrder.sortBy}`
      ),
    enabled: !!companyId,
    refetchOnWindowFocus: false,
  });

/**
 * Download Excel template for a process flow.
 */
export const downloadTemplate = async (
  companyId: string,
  processFlowId: string,
  processName?: string
): Promise<void> => {
  const blob = await fetchBlobFromApi(
    `${REACT_APP_DARWIN_URL}/massive-load/${companyId}/download-template/${processFlowId}`
  );
  downloadBlob(blob, `${processName || 'template'}.xlsx`);
};
